import { PanelRow, PanelCell, Grid, Cell, Icon, Field, Button } from '@teamsnap/teamsnap-ui';
import * as React from 'react';
import UUIDSearchForm from './uuid-search-form';
import './org-legacy-uuid-section.scss';

export interface Props {
  uuid?: number;
  onPopulate?: (data) => void;
  setTsPersistentId: React.Dispatch<React.SetStateAction<boolean>>;
  setAddLegacySeasons: React.Dispatch<React.SetStateAction<boolean>>;
  addLegacySeasons: boolean;
}

const OrgLegacyUuidSection: React.FunctionComponent<Props> = ({
  uuid,
  onPopulate,
  setTsPersistentId,
  setAddLegacySeasons,
  addLegacySeasons,
}) => {
  const [stubOrgData, setStubOrgData] = React.useState(null);
  const [showLegacySeasonsCheck, setShowLegacySeasonsCheck] = React.useState<boolean>(false);

  const populateData = (newOrgData) => {
    setTsPersistentId(newOrgData.id);
    setShowLegacySeasonsCheck(true);

    onPopulate(newOrgData);
  };

  return (
    <PanelRow isWithCells={true} mods="Panel-row--header">
      <PanelCell mods="Panel-cell--header u-size3of12 u-flex">
        <h4>Club & League UUID</h4>
      </PanelCell>
      <PanelCell mods="u-size9of12">
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12 u-colorWarning">
            <div className="u-spaceBottomMd">
              If this organization is being migrated from the legacy Club & League system please enter the org's
              existing UUID. This will be shared with integrated applications, such as ChurnZero, so that IDs do not
              change when migrating customers across TeamSnap products. If this is a brand new organization, then leave
              this field blank and a Org ID will be assigned automatically.
            </div>
          </Cell>
        </Grid>
        <Grid isWithGutter={true}>
          <Cell mods="u-size12of12">
            <UUIDSearchForm setStubOrgData={setStubOrgData} isDisabled={uuid ? true : false} />

            {stubOrgData && (
              <>
                <button
                  key={stubOrgData.id}
                  onClick={() => populateData(stubOrgData)}
                  type="button"
                  className="org-uuid-button u-padSidesMd u-padEndsSm u-spaceTopMd u-border u-borderRadiusMd u-borderColorDefault u-textLeft"
                >
                  <span className="u-block u-fontSizeLg">{stubOrgData.name}</span>
                  <span className="u-spaceXs u-block u-fontSizeSm">{stubOrgData.id}</span>
                  <p className="u-textCenter u-fontSizeSm u-spaceTopMd u-colorWarning">
                    Click to use this C/L data &rarr;
                  </p>
                </button>
                {showLegacySeasonsCheck && (
                  <div>
                    <input
                      type="checkbox"
                      className="u-spaceTopSm"
                      name="addLegacySeason"
                      onClick={() => setAddLegacySeasons(!addLegacySeasons)}
                    />
                    <label htmlFor="addLegacySeason">Add legacy seasons to new organization</label>
                  </div>
                )}
              </>
            )}
          </Cell>
        </Grid>
      </PanelCell>
    </PanelRow>
  );
};

export default OrgLegacyUuidSection;
